import { SearchField } from '@akyga/shared-ui/SearchField';

export default SearchField;
